import { createFileRoute } from '@tanstack/react-router'

import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { deliveryShareIdSchema } from '@/lib/services/delivery-shares/delivery-shares.schema'

import { DeliveryRouteEditPage, loadDeliveryRoute } from './$deliveryShareId'

export const Route = createFileRoute(
  '/_authenticated/$orgId/sales-orders/delivery-routes/$deliveryShareId/edit'
)({
  component: () => <DeliveryRouteEditPage routeApi={Route} />,
  head: adminRouteTitleHead,
  params: {
    parse: (params) => deliveryShareIdSchema.parse(params),
  },
  loader: ({ context, params }) => loadDeliveryRoute({ context, params, requireEdit: true }),
})
